import { PropsWithChildren } from 'react';
import { Stack, StackProps } from '@mui/material';

export const TeamContainer = ({ children, ...boxProps }: StackProps & PropsWithChildren) => {
  return (
    <Stack
      {...boxProps}
      sx={{
        paddingLeft: { xs: 0, md: '50%' },
        ...boxProps?.sx,
      }}
    >
      {children}
    </Stack>
  );
};
